// extracted by mini-css-extract-plugin
export default {"component":"ErrorMessage__component___btgkD","text":"ErrorMessage__text___ScvGJ"};